import { HelpOutline } from "@mui/icons-material";
import { Box, IconButton, Tab, ThemeProvider, Tooltip } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import ModeIndicator from "../salesInvoice/ModeIndicator";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Loader, Printer, Save, Sparkles, View, History } from "lucide-react";
import TimelineTab from "../salesInvoice/TimelineTab";
import ConfigCard from "../salesInvoice/ConfigCard";
import SummaryTotalCard from "../salesInvoice/SummaryTotalCard";
import ModificationCommentModal from "../salesInvoice/ModificationCommentModal";
import Modal from "../common/CommonModal";
import { getTodayDate } from "../../utils/constants";
import {
  DOCUMENT_TYPES,
  fetchDocumentNumber,
  fetchUnitOptionsForItems,
  getDocumentConfig,
  MODIFICATION_TYPES,
  theme,
  tooltipContent,
} from "../config/DocumentConfig";
import { useLocation, useNavigate } from "react-router-dom";
import useApi from "../../hooks/useApi";
import { purchaseData } from "../salesInvoice/data";
import PurchaseOrderGeneral from "./PurchaseOrderGeneral";
import PurchaseOrderTermsAndDelivery from "./PurchaseOrderTerms";
import { calculateRowValues } from "../config/PurchaseOrderTableConfig";
import PurchaseOrderTable from "./PurchaseOrderTable";

const PurchaseOrder = ({ documentType = DOCUMENT_TYPES.PURCHASE_ORDER }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { request } = useApi();
  const config = getDocumentConfig(documentType);

  const DEPARTMENT =
    localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const COMPANY_CODE = localStorage?.getItem("companyCode") || "DOODDEMO";
  const CURRENT_USER = localStorage?.getItem("currentUserName") || "admin";
  const CURRENT_USER_OBJECT = localStorage?.getItem("currentUser")
    ? JSON.parse(localStorage?.getItem("currentUser"))
    : {};
  let API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";
  const todayDate = getTodayDate();
  const documentNoFromState = location?.state?.docNo || null;
  const modeFromState = location?.state?.mode || "new";
  const [isSaving, setIsSaving] = useState(false);
  const [mode, setMode] = useState(modeFromState);

  const [parentTabValue, setParentTabValue] = useState("1");
  const [supplierData, setSupplierData] = useState(null);
  console.log("Supplier Data in Purchase Order", supplierData);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [items, setItems] = useState(purchaseData);
  const [currentLocation, setCurrentLocation] = useState("MAIN SHOP");
  const [showSidebar, setShowSidebar] = useState(false);
  const [initialRowUnitOptions, setInitialRowUnitOptions] = useState({});
  const [accountData, setAccountData] = useState(null);

  const [discountAmount, setDiscountAmount] = useState("");
  const [roundOff, setRoundOff] = useState("");

  const [autoVatIsOn, setAutoVatIsOn] = useState(true);
  const [vatAmountManual, setVatAmountManual] = useState(null);
  const [transferModalOpen, setIsTransferModalOpen] = useState(false);
  const [isModificationModalOpen, setIsModificationModalOpen] = useState(false);
  const [aiDocumentUploader, setIsAiDocumentUploader] = useState(false);

  const handleParentTabChange = (event, newValue) => {
    setParentTabValue(newValue);
  };
  const VATPERCENTAGE = CURRENT_USER_OBJECT[0]?.vatp;

  const [documentData, setDocumentData] = useState({
    purchaseType: config.defaultValues.purchaseType || "Local",
    vatStatus: "VAT Applied",
    documentNo: "",
    date: todayDate,
    paymentMode: "credit",
    invNo: "",
    supplier: "",
    unregSupplier: "",
    trn: "",
    dueDays: "",
    dueDate: todayDate,
    cfAgent: "",
    shipRef: "",
    docDate: todayDate,
    jobCode: "",
    remarks: "",
    currency: "AED",
    currencyRate: "1",
    voucherType: "",
    creditAcc: "",
    debitAcc: "",
    invNumber: "",
    vatAcc: "",
    delivery: "",
    terms: "",
    lcNo: "",
    shipDate: todayDate,
  });
  const fetchDocumentDetail = async (documentNo) => {
    try {
      const url = config.apiEndpoints.detail(
        COMPANY_CODE,
        documentNo,
        DEPARTMENT,
      );
      const fullUrl = `${BASE_URL}${url}`;
      const response = await request({ url: fullUrl, method: "GET" });

      if (!response || response.length === 0) return;

      const header = response[0];
      // console.log("Fetched Purchase Order Detail:", response[0].validity);
      const currencyRate =
        header.po_fcrate != null ? String(header.po_fcrate) : "1";

      setDocumentData((prev) => ({
        ...prev,

        // Basic info
        documentNo: String(header.po_no ?? ""),
        date: header.po_date ? header.po_date.slice(0, 10) : prev.date,
        dueDate: header.due_date ? header.due_date.slice(0, 10) : prev.dueDate,

        // Account / Supplier
        supplier: header.cust_acc || "",
        unregSupplier: header.consignee || "",
        creditAcc: header.cust_acc || "",
        debitAcc: header.cust_acc || "",
        trn: header.CCNO || "",

        // Reference Numbers
        invNo: header.inv_no || "",
        invNumber: header.po_ref || "",
        voucherType: header.jv_num || prev.voucherType,

        // Currency
        currency: header.fc || "AED",
        currencyRate,

        // Amounts
        remarks: header.comments || "",
        discountAmount: header.po_disc || 0,
        roundOff: header.rdoff || 0,

        // VAT
        vatStatus: header.po_doc || "VAT Applied",

        // Other
        jobCode: header.job_code || "",
        purchaseType: header.local === "I" ? "Import" : "Local",

        terms: header.payment || "",
        delivery: header.foot1 || "",
        shipRef: header.po_ref || "",
        cfAgent: header.validity || "Testtttttttt",
        lcNo: header.lpo_no || "",
        // discountAmount: header.po_disc || 0,
      }));
      // supplier object
      const supplierObj = {
        ACCOUNT: header.cust_acc,
        DESCRIPTION: header.accdesc,
        TRN: header.trn,
      };

      setSupplierData(supplierObj);
      setSelectedSupplier(supplierObj);
      setDiscountAmount(header.po_disc || 0)
      setRoundOff(header.rdoff || 0)

      // LINE ITEMS MAPPING
      const mappedItems = response.map((row, index) => ({
        id: index + 1,
        sino: index + 1,
        code: row.po_icode || "",
        description: row.idesc || "",
        location: row.po_locn || "",
        unit: row.unit || "",
        qty: row.po_qty || 0,
        unitCost: Number(row.po_fccost) || 0,
        amount: Number(row.po_amount) || 0,
        vatEnabled: row.vat !== false,
        vatPercent:
          row.vatpercent ||
          (header.po_doc === "VAT Applied" ? VATPERCENTAGE : 0),
        vatAmount: Number(row.vatamt) || 0,
        total: Number(row.po_amount) + (Number(row.vatamt) || 0),
        remarks: row.ALIAS || "",
        pono: row.po_no,
      }));

      setItems(mappedItems);
    } catch (err) {
      console.error(`Failed to fetch ${config.title} detail:`, err);
    }
  };

  const initializeDocument = useCallback(async () => {
    try {
      const { voucherType, documentNo } = await fetchDocumentNumber(
        documentType,
        documentData.paymentMode,
        BASE_URL,
        COMPANY_CODE,
        DEPARTMENT,
      );

      if (documentNo) {
        setDocumentData((prev) => ({
          ...prev,
          documentNo: documentNo,
          voucherType,
        }));
      }
      console.log("Voucher Type:", voucherType, documentNo);
    } catch (err) {
      console.error("Error initializing document:", err);
    }
  }, [
    documentType,
    documentData?.paymentMode,
    BASE_URL,
    COMPANY_CODE,
    DEPARTMENT,
  ]);

  useEffect(() => {
    if (documentNoFromState && request) {
      fetchDocumentDetail(documentNoFromState);
    }
  }, [documentNoFromState, documentType]);

  // Auto-save logic: persist new document drafts to localStorage
  useEffect(() => {
    if (
      mode === "new" &&
      items.some((it) => it.code && it.code.trim() !== "")
    ) {
      const draft = {
        items,
      };
      localStorage.setItem(
        `cubix_draft_${documentType}`,
        JSON.stringify(draft),
      );
    }
  }, [items, documentType, mode]);

  const handleRetrieveDraft = useCallback(() => {
    const savedDraft = localStorage.getItem(`cubix_draft_${documentType}`);
    if (savedDraft) {
      const draft = JSON.parse(savedDraft);
      const confirmRestore = window.confirm(
        "Found a previously saved draft for this Purchase Order. Would you like to restore it?",
      );
      if (confirmRestore) {
        if (draft.items) setItems(draft.items);
      }
    } else {
      alert("No draft found for this document type.");
    }
  }, [documentType]);

  // Keyboard shortcut listener (Alt + R to restore)
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.altKey && e.key === "r") {
        e.preventDefault();
        handleRetrieveDraft();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleRetrieveDraft]);

  // Navigation Guard: Warn user before leaving with unsaved items
  useEffect(() => {
    const hasUnsavedChanges =
      mode === "new" && items.some((it) => it.code && it.code.trim() !== "");

    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue =
          "You have unsaved items in your draft. Are you sure you want to leave?";
        return e.returnValue;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [items, mode]);

  useEffect(() => {
    if (mode === "new" && documentData.paymentMode) {
      // ensure paymentMode exists
      initializeDocument();
    }
  }, [mode, initializeDocument, documentData.paymentMode]);

  const getVatPercent = (documentData) =>
    documentData.vatStatus === "VAT Applied" ? VATPERCENTAGE : 0;

  const calculateTotals = () => {
    const round = (val) => Math.round(Number(val) * 100) / 100;

    const processedItems = items.map((item) =>
      calculateRowValues(item, documentData, {
        items,
      }),
    );

    const rowTaxableSum = round(
      processedItems.reduce((sum, item) => sum + (Number(item.amount) || 0), 0),
    );

    const rowVatSum = round(
      processedItems.reduce(
        (sum, item) => sum + (Number(item.vatAmount) || 0),
        0,
      ),
    );
    const grossAmount = round(
      processedItems.reduce((sum, item) => sum + (Number(item.total) || 0), 0),
    );

    const globalDiscount = Number(discountAmount) || 0;
    const roundOffValue = Number(roundOff) || 0;

    const taxableAmount = round(rowTaxableSum - globalDiscount - roundOffValue);

    const totalVat =
      !autoVatIsOn && vatAmountManual !== null
        ? round(vatAmountManual)
        : globalDiscount > 0
          ? round(taxableAmount * (VATPERCENTAGE / 100))
          : rowVatSum;

    const totalAmount = round(taxableAmount + totalVat);

    const netAmount = round(totalAmount);

    const currencyRate = Number(documentData.currencyRate) || 1;
    const bcAmt = round(netAmount * currencyRate);

    return {
      grossAmount: grossAmount.toFixed(2),
      taxableAmount: taxableAmount.toFixed(2),
      vatAmount: totalVat.toFixed(2),
      discountAmount: globalDiscount.toFixed(2),
      roundOff: roundOffValue.toFixed(2),
      netAmount: netAmount.toFixed(2),
      // advanceAmount: advance.toFixed(2),
      bcAmt: bcAmt.toFixed(2),
    };
  };
  // Credit limit check helper functions
  async function fetchRefCount(accountId) {
    try {
      const res = await fetch(
        `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/PENDBILL/${accountId}/-`,
      );
      const data = await res.json();
      return Number(data?.[0]?.RefCount || 0);
    } catch (err) {
      console.error("Error fetching RefCount:", err);
      return 0;
    }
  }
  const totals = calculateTotals();
  function isCreditLimitExceeded(accountData, totalAmount, refCount = 0) {
    const creditMethod = String(accountData?.CREDITMETHOD || "").toUpperCase();
    const isCreditCustomer = documentData?.paymentType === "credit";

    const isBlocked = creditMethod === "BLOCKED";
    const isCreditBlock = creditMethod === "CREDIT BLOCK";
    const isOpen = creditMethod === "OPEN";

    const dr = Number(accountData?.debit ?? accountData?.dr ?? 0);
    const cr = Number(accountData?.credit ?? accountData?.cr ?? 0);
    const balance = dr - cr;

    const pendbill = Number(accountData?.discount || 0);
    const duedays = Number(accountData?.duedays || 0);
    const ddays = Number(accountData?.ddays || 0);

    if (!isCreditCustomer) {
      return { blocked: false, exceeded: false, overdue: false, balance };
    }

    if (isOpen) {
      return { blocked: false, exceeded: false, overdue: false, balance };
    }

    if (isBlocked) {
      return { blocked: true, exceeded: false, overdue: false, balance };
    }

    if (isCreditBlock && totalAmount > balance) {
      return { blocked: false, exceeded: true, overdue: false, balance };
    }

    if (ddays > 0 && duedays > ddays) {
      return { blocked: false, exceeded: false, overdue: true, balance };
    }

    if (pendbill > 0 && refCount > pendbill) {
      return { blocked: false, exceeded: true, overdue: false, balance };
    }

    return { blocked: false, exceeded: false, overdue: false, balance };
  }

  // Credit limit validation
  useEffect(() => {
    if (!accountData?.CREDITMETHOD) return;

    const runChecks = async () => {
      const totalAmount = Number(totals?.totalAmount) || 0;
      const isCreditCustomer = documentData?.paymentType === "credit";

      if (!isCreditCustomer) return;

      const pendbill = Number(accountData?.discount || 0);
      const refCount =
        pendbill > 0 ? await fetchRefCount(accountData?.account) : 0;

      const { blocked, exceeded, overdue } = isCreditLimitExceeded(
        accountData,
        totalAmount,
        refCount,
      );

      if (blocked) {
        alert("This account is BLOCKED");
        return;
      }

      if (overdue) {
        alert("Customer Bill Overdue");
        return;
      }

      if (exceeded) {
        alert("Credit Limit Exceeded");
        return;
      }
    };

    runChecks();
  }, [totals?.totalAmount, accountData, documentData?.paymentType]);
  const refreshStockDocument = async (
    companyCode,
    documentNumber,
    department,
  ) => {
    const response = await fetch(
      `${BASE_URL}/api/CRMStockRefreshDoc/${companyCode}/PORD/${documentNumber}/${department}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (!response.ok) {
      throw new Error("Stock refresh failed");
    }

    return response.json();
  };
  const handleSave = async () => {
    try {
      setIsSaving(true);

      const filteredItems = items.filter(
        (item) => item.code && item.code.trim() !== "",
      );

      if (filteredItems.length === 0) {
        alert("Please add at least one item to the purchase order.");
        setIsSaving(false);
        return;
      }

      if (!supplierData || !supplierData.ACCOUNT) {
        alert("Please select a supplier before saving.");
        setIsSaving(false);
        return;
      }
      if (!documentData.documentNo) {
        alert("Document number is missing.");
        setIsSaving(false);
        return;
      }

      if (!documentData.trn || documentData.trn.length !== 15) {
        alert("Please enter a valid TRN (15 digits).");
        setIsSaving(false);
        return;
      }

      const payloadLines = [];

      filteredItems.forEach((item, index) => {
        const processedItem = calculateRowValues(item, documentData, { items });

        const linePayload = {
          Slno: String(index + 1),
          code: item.code || "",
          description: item.description || "",
          locn: item.location || "",
          unit: item.unit || "",
          qty: String(Number(item.qty) || 0),
          UnitCost: String(Number(item.unitCost) || 0),
          UnitBCCost: String(Number(item.unitBCCost) || 0),
          AmountLine: String(Number(processedItem.amount) || 0),
          OthCost: String(Number(item.othCost) || 0),
          x: item.x || "",
          cntrl: item.cntrl || "",
          frac: String(Number(item.fraction) || 1),
          vat_percent: String(getVatPercent(documentData)),
          VatamtLine: String(Number(processedItem.vatAmount) || 0),
          Mastinfo: item.mastInfo || "0",
          total: String(Number(processedItem.total) || 0),
          oem: item.oem || "",
          group: item.group || "",
          disc_percent: String(Number(item["Discount%"] || 0)),
          RemarksLine: item.remarks || "",
          TrDoc: "",
          DocNo: "",
        };

        payloadLines.push(linePayload);
      });

      const masterPayload = {
        cmpcode: COMPANY_CODE,
        mode: mode === "edit" ? "EDIT" : "NEW",
        po_no: documentData.documentNo || "",
        po_date: documentData.date || todayDate,
        account: documentData.supplier?.ACCOUNT || supplierData?.ACCOUNT || "",
        accdesc:
          documentData.supplier?.DESCRIPTION || supplierData?.DESCRIPTION || "",
        local: documentData.purchaseType === "Local" ? "L" : "I",
        comments: documentData.remarks || "",
        sale_man: CURRENT_USER_OBJECT[0]?.sales_man || "",
        po_ref: documentData.invNumber || "",
        po_doc: documentData.documentNo || "",
        fc: documentData.currency || "AED",
        po_amount: String(Number(totals?.netAmount) || 0),
        po_fcamount: String(Number(totals?.netAmount) || 0),
        po_fcrate: String(Number(documentData.currencyRate) || 1),
        po_disc: String(Number(discountAmount) || 0),
        duedate: documentData.dueDate || todayDate,
        terms: documentData.terms || "",
        attn: documentData.unregSupplier || "",
        shipref: documentData.shipRef || "",
        delivery: documentData.delivery || "",
        remarks: documentData.remarks || "",
        vattype: documentData.vatStatus || "",
        vatamt: String(Number(totals?.vatAmount) || 0),
        cfagent: documentData.cfAgent || "",
        username: CURRENT_USER || "admin",
        lcno: documentData.lcNo || "",
        deptno: DEPARTMENT,
        trn: documentData.trn || "",
        jobcode: documentData.jobCode || "",
        rdoff: String(Number(roundOff) || 0),
      };

      // Combine master data with line items
      const requestPayload = payloadLines.map((line) => ({
        ...masterPayload,
        ...line,
      }));

      console.log("Purchase Order Payload:", requestPayload);

      // Send to API
      const apiUrl = `${BASE_URL}${config.apiEndpoints.save}`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestPayload),
      });

      const result = await response.json();
      console.log("API Response:", result);
      await refreshStockDocument(COMPANY_CODE, result.pono, DEPARTMENT);

      if (response.ok && result) {
        const poNumber = result[0]?.po_no || documentData.documentNo;
        alert(`Purchase Order #${poNumber} saved successfully!`);

        // Clear the draft after successful save
        localStorage.removeItem(`cubix_draft_${documentType}`);

        // Navigate to purchase order list
        navigate("/purchase_order_list");
      } else {
        alert(
          `Failed to save Purchase Order: ${result?.message || "Unknown error"}`,
        );
      }
    } catch (error) {
      console.error("Error saving Purchase Order:", error);
      alert(`Error saving Purchase Order: ${error.message}`);
    } finally {
      setIsSaving(false);
    }
  };
  const handlePrint = async () => {
    // console.log("Print Logged");
    // alert("Document Printed Successfully");
    navigate("/purchase_order_list");
  };

  const handleTransfer = async (docType, selectedRows) => {
    setIsTransferModalOpen(false);
    console.log("Selected rows from Parent component", selectedRows);
    const docNos = selectedRows
      .map((row) => {
        return (
          row.QUOTNO ||
          row.inv_no ||
          row.ORDNO ||
          row.do_no ||
          row.SONO ||
          row.PONO
        );
      })
      .join(",");
    console.log("Doc number transfered", docNos);
    const masterUrl = `${BASE_URL}${config.apiEndpoints.transfer.master(
      COMPANY_CODE,
      DEPARTMENT,
      docNos,
      docType,
    )}`;
    const detailUrl = `${BASE_URL}${config.apiEndpoints.transfer.detail(
      COMPANY_CODE,
      DEPARTMENT,
      docNos,
      docType,
    )}`;

    try {
      const masterRes = await fetch(masterUrl);
      const masterData = await masterRes.json();
      console.log("Master Transfer Response:", masterData);

      if (masterData && masterData.length > 0) {
        const totalDiscount = masterData?.reduce(
          (acc, row) => acc + (row.so_disc || 0),
          0,
        );
        const main = masterData[0];

        setDocumentData((prev) => ({
          ...prev,
          supplier: main.cust_acc,
          salesman: main.sale_man?.trim(),
          so_ref: main.so_ref,
          areacode: main.area_code,
          duedate: main.due_date?.slice(0, 10),
          terms: "0",
          date: main.so_date?.slice(0, 10),
          paymentType: "credit",
          currency: main.fc,
          currencyRate: main.so_fcrate || 1,
          remarks: main.comments || "",
        }));

        setDiscountAmount(totalDiscount);
      }

      const detailRes = await fetch(detailUrl);
      const detailData = await detailRes.json();
      console.log("Detail Transfer Response:", detailData);
      // Item mapping for transfered data
      if (detailData && detailData.length > 0) {
        const items = detailData.map((row, idx) => ({
          id: idx + 1,
          sino: idx + 1,
          code: row.code || row.po_icode || row.so_icode || row.idesc,
          description: row.idesc,
          location: row.po_locn || row.locn,
          unit: row.unit?.trim(),
          qty: row.po_qty || row.so_qty,
          unitCost: row.cost_unit || row.so_fccost,
          UnitCost: String(Number(row.cost_unit) || 0),
          discount: row.po_fdisc || row.so_disc || row.so_fdisc,
          fraction: row.fraction,
        }));

        const initialRowUnitOptions = await fetchUnitOptionsForItems(
          items,
          BASE_URL,
          COMPANY_CODE,
        );
        setItems(items);
        setInitialRowUnitOptions(initialRowUnitOptions);
      }
    } catch (err) {
      console.error("Error fetching transfer data:", err);
    }
  };

  return (
    <div className="w-full relative">
      <div className="flex items-center justify-between lg:px-10 px-2 mb-2 gap-2">
        <div className="flex items-center gap-3">
          <h1 className="text-xl font-semibold">{config.title}</h1>
        </div>

        <Tooltip title={tooltipContent} sx={{ margin: 0, padding: 0 }}>
          <IconButton>
            <HelpOutline
              className="text-blue-600 bg-white rounded-full"
              fontSize="medium"
            />
          </IconButton>
        </Tooltip>
      </div>
      <ModeIndicator mode={mode} documentType={documentType} />
      <div className="w-full rounded-lg">
        <div className="lg:px-10">
          <div className="bg-gray-50 border lg:p-3 rounded-lg shadow pb-6">
            <ThemeProvider theme={theme}>
              <TabContext value={parentTabValue}>
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <TabList onChange={handleParentTabChange}>
                    <Tab label="General" value="1" sx={{ padding: 0 }} />
                    <Tab
                      label="Terms & Delivery"
                      value="2"
                      sx={{ padding: 0 }}
                    />
                    <Tab label="Timeline" value="3" sx={{ padding: 0 }} />
                  </TabList>
                  <div className="lg:flex hidden items-center gap-3">
                    <button
                      onClick={handleRetrieveDraft}
                      className="flex items-center gap-2 px-5 py-2.5 bg-amber-500 text-white text-sm font-medium rounded-lg shadow hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-amber-400 transition active:scale-95"
                      title="Restore last unsaved draft (Alt+R)"
                    >
                      <History className="w-4 h-4" />
                      Restore Draft (Alt + R)
                    </button>
                    <button
                      //   onClick={handlePrint}
                      onClick={() => {
                        navigate("/purchase_order_list");
                      }}
                      className="flex items-center gap-2 px-5 py-2.5 border border-indigo-600 text-indigo-600 text-sm font-medium rounded-lg shadow hover:text-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <View className="w-4 h-4" />
                      View
                    </button>
                    <button
                      onClick={() => {
                        if (mode === "edit") {
                          setIsModificationModalOpen(true);
                        } else {
                          handleSave();
                        }
                      }}
                      disabled={mode === "view" || isSaving}
                      className="flex items-center gap-2 px-5 py-2.5 bg-green-500 text-white text-sm font-medium rounded-lg shadow hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isSaving ? (
                        <>
                          <Loader className="w-4 h-4 animate-spin" />
                          Saving...
                        </>
                      ) : (
                        <>
                          <Save className="w-4 h-4" />
                          {mode === "edit" ? "Update" : "Save"}
                        </>
                      )}
                    </button>
                  </div>
                </Box>
                <TabPanel value="1" sx={{ p: 0, paddingX: 0 }}>
                  <PurchaseOrderGeneral
                    purchaseOrderData={documentData}
                    setPurchaseOrderData={setDocumentData}
                    COMPANY_CODE={COMPANY_CODE}
                    DEPARTMENT_NO={DEPARTMENT}
                    BASE_URL={BASE_URL}
                    setSupplierData={setSupplierData}
                    selectedSupplier={selectedSupplier}
                    setSelectedSupplier={setSelectedSupplier}
                    supplierData={supplierData}
                    documentType="PURCHASEORDER"
                    onRestoreDraft={handleRetrieveDraft}
                  />
                </TabPanel>
                <TabPanel value="2" sx={{ p: 0, paddingX: 0 }}>
                  <PurchaseOrderTermsAndDelivery
                    purchaseOthersData={documentData}
                    setPurchaseOthersData={setDocumentData}
                  />
                </TabPanel>
                <TabPanel value="3" sx={{ p: 1 }}>
                  <TimelineTab
                    BASE_URL={BASE_URL}
                    DEPARTMENT={DEPARTMENT}
                    modificationType={MODIFICATION_TYPES[documentType] || null}
                    invoiceId={documentNoFromState}
                    COMPANY_CODE={COMPANY_CODE}
                  />
                </TabPanel>
              </TabContext>
            </ThemeProvider>
          </div>
        </div>

        <main className="w-full mt-4 relative">
          <PurchaseOrderTable
            items={items}
            onItemsChange={setItems}
            setShowSidebar={setShowSidebar}
            // setItemInfo={setItemInfo}
            setCurrentLocation={setCurrentLocation}
            extraFields={[]}
            purchaseData={documentData}
            initialRowUnitOptions={initialRowUnitOptions}
            setInitialRowUnitOptions={setInitialRowUnitOptions}
            // isOtherCostEnabled={false}
            // setIsOtherCostEnabled={setIsOtherCostEnabled}
            // otherCosts={otherCosts}
            // setOtherCosts={setOtherCosts}
            calculateRowValues={calculateRowValues}
            invoiceData={documentData}
            getVatPercent={getVatPercent}
            BASE_URL={BASE_URL}
            COMPANY_CODE={COMPANY_CODE}
            DEPARTMENT_NO={DEPARTMENT}
            documentType={documentType}
          />
        </main>
        <div className="w-full lg:px-10 p-1 mt-2">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-start">
            <ConfigCard
              invoiceData={documentData}
              setAutoVatIsOn={setAutoVatIsOn}
              setInvoiceData={setDocumentData}
              autoVatIsOn={autoVatIsOn}
              documentType={documentType}
              config={config}
              setIsModalOpen={setIsTransferModalOpen}
              isModalOpen={transferModalOpen}
              fetchDocumentDetail={fetchDocumentDetail}
              invoiceNoFromState={documentNoFromState}
              accountData={supplierData}
              onTransfer={handleTransfer}
            />

            <SummaryTotalCard
              totals={totals}
              setInvoiceData={setDocumentData}
              invoiceData={documentData}
              handlePrint={handlePrint}
              handleSave={handleSave}
              roundOff={roundOff}
              setRoundOff={setRoundOff}
              discountAmount={discountAmount}
              setDiscountAmount={setDiscountAmount}
              mode={mode}
              autoVatIsOn={autoVatIsOn}
              setVatAmountManual={setVatAmountManual}
              config={config}
              setIsModificationModalOpen={setIsModificationModalOpen}
            />
          </div>
        </div>
      </div>
      <Modal
        isOpen={isModificationModalOpen}
        onClose={() => setIsModificationModalOpen(false)}
        size="md"
        header={true}
        title="Update Confirmation"
        showFullScreen={false}
      >
        <ModificationCommentModal
          isOpen={isModificationModalOpen}
          onClose={() => setIsModificationModalOpen(false)}
          handleSave={handleSave}
          documentData={documentData}
          documentType={documentType}
          COMPANY_CODE={COMPANY_CODE}
          DEPARTMENT={DEPARTMENT}
          CURRENT_USER={CURRENT_USER}
          BASE_URL={BASE_URL}
          setIsModificationModalOpen={setIsModificationModalOpen}
        />
      </Modal>
    </div>
  );
};

export default PurchaseOrder;
